import React from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";

import { BRAND_BLUE } from "../constants/assetValuationConstants";

const BarcodePdfModal = ({
    isOpen,
    onToggle,
    onClose,
    isLoading = false,
    categoryEntries = [],
}) => (
    <Modal isOpen={isOpen} toggle={onToggle} size="lg">
        <ModalHeader toggle={onClose}>
            <i className="ri-barcode-box-line me-2" style={{ color: BRAND_BLUE }}></i>
            Barcode PDFs by Category
        </ModalHeader>
        <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {isLoading ? (
                <div className="text-center py-4">
                    <Spinner
                        style={{
                            width: "3rem",
                            height: "3rem",
                            color: BRAND_BLUE,
                        }}
                    />
                    <p className="mt-3 text-muted">Loading barcode PDFs...</p>
                </div>
            ) : categoryEntries.length === 0 ? (
                <p className="text-muted mb-0">No barcode PDF files found.</p>
            ) : (
                <div className="d-flex flex-column gap-3">
                    {categoryEntries.map(([categoryName, files]) => (
                        <div key={categoryName}>
                            <h6 className="mb-2">{categoryName}</h6>
                            {files.length === 0 ? (
                                <p className="text-muted mb-2">No files.</p>
                            ) : (
                                <div className="d-flex flex-column gap-2">
                                    {files.map((file) => (
                                        <div
                                            key={file.id || file.filename}
                                            className="d-flex align-items-center justify-content-between border rounded px-3 py-2"
                                        >
                                            <div className="me-3 text-truncate">
                                                <i className="ri-file-pdf-line me-2 text-danger"></i>
                                                <span className="fw-medium">{file.filename}</span>
                                            </div>
                                            <a
                                                href={file.downloadUrl || file.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-primary"
                                                style={{
                                                    backgroundColor: BRAND_BLUE,
                                                    borderColor: BRAND_BLUE,
                                                }}
                                            >
                                                <i className="ri-download-line me-1"></i>
                                                Download
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={onClose}>
                Close
            </Button>
        </ModalFooter>
    </Modal>
);

export default BarcodePdfModal;
